'use client'

import { GlobalErrorScreen, type GlobalErrorScreenProps } from '@/shell'

/**
 * Next.js resolves this file by name, so it is an adapter and owns nothing (ADR 0010).
 * The screen is `shell/global-error-screen.tsx`, which renders its own document.
 */
export default function GlobalError(props: GlobalErrorScreenProps) {
  return <GlobalErrorScreen {...props} />
}
